<template>
  <b-card class="mb-5">
    <b-row>
      <b-col md="12">
          <h3>{{$route.name}}</h3>
          <b-breadcrumb>
              <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
              <b-breadcrumb-item><router-link to="/vehicle">Vehicle Dashboard</router-link></b-breadcrumb-item>
              <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
      </b-col>
    </b-row>
    <div class="border-bottom mb-1"/>
    <form v-on:submit.prevent="doSubmit" class="mt-3">
      <div>
        <b-tabs small card>
          <b-tab title="Model">
            <b-row class="mb-3 pr-2">
              <b-col md="5">
                <label class="labels">Brand *</label>
                <b-form-input name="merk" v-model="model.merk" placeholder="Enter Brand" v-bind:class="errors.has('merk') ? 'is-invalid':''" v-validate="modelValidations.merk" :error="errors.first('merk')"  />
              </b-col>
              <!--<b-col md="1">
                <b-button variant="primary" class="btn-custom" @click="doModalCategory()" style="margin-top:1.9em; margin-left:-13px!important;"><font-awesome-icon icon="plus"/></b-button>
              </b-col>-->
              <b-col md="2">
              </b-col>
              <b-col md="5">
                <label class="labels">Company *</label>
                <b-form-select id="field-company" name="company" v-model="model.company" v-bind:class="errors.has('company') ? 'is-invalid':''" v-validate="modelValidations.company" :error="errors.first('company')" :options="companyList">
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>Please Select Company</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <!--<b-button variant="primary" class="btn-back btn-custom mt-5" :to="'/settings/vehicle/create'" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>-->
            </b-row>
            <b-row>
              <b-col md="5">
                <label class="labels">Model *</label>
                <b-form-input name="model" v-model="model.model" placeholder="Enter Model" v-bind:class="errors.has('model') ? 'is-invalid':''" v-validate="modelValidations.model" :error="errors.first('model')"  />
              </b-col>
              <!--<b-col md="1">
                <b-button variant="primary" class="btn-custom" @click="doModalBranch()" style="margin-top:1.9em; margin-left:-15px!important;"><font-awesome-icon icon="plus"/></b-button>
              </b-col>-->
              <b-col md="2">
              </b-col>
              <b-col md="5">
                <label class="labels">Branch *</label>
                <b-form-select name="branch" v-model="model.branch" v-bind:class="errors.has('branch') ? 'is-invalid':''" v-validate="modelValidations.branch" :error="errors.first('branch')" :options="branchList">
                </b-form-select>
              </b-col>
              <b-button variant="light" style="margin-left:-75px!important; margin-top:29px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
              </b-button>
              <!--<b-button variant="primary" class="btn-back btn-custom mt-5" :to="'/settings/vehicle/create'" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>-->
            </b-row>
            <b-row>
              <b-col md="5 mt-3">
                <label class="labels">Category *</label>
                <b-form-select name="category" v-model="model.category" v-bind:class="errors.has('category') ? 'is-invalid':''" v-validate="modelValidations.category" :error="errors.first('category')" :options="categoryList">
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>Please Select Category</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <b-button variant="primary" class="btn-custom mt-5" @click="doModalCategory()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button>
            </b-row>
          </b-tab>
          <b-tab title="Specification">
            <b-row class="mb-3">
              <b-col md="5">
                <label class="labels">Plate Number *</label>
                <b-form-input name="plate" placeholder="Enter Plate Number" v-model="model.plate" v-bind:class="errors.has('plate') ? 'is-invalid':''" v-validate="modelValidations.plate" :error="errors.first('plate')"  />
              </b-col>
              <b-col md="2">
              </b-col>
              <b-col md="5">
                <label class="labels">Fuel *</label>
                <b-form-input name="fuel" v-model="model.fuel" placeholder="Enter Fuel" v-bind:class="errors.has('fuel') ? 'is-invalid':''" v-validate="modelValidations.fuel" :error="errors.first('fuel')"  />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5">
                <label class="labels">Color *</label>
                <b-form-input name="color" v-model="model.color" placeholder="Enter Color" v-bind:class="errors.has('color') ? 'is-invalid':''" v-validate="modelValidations.color" :error="errors.first('color')"  />
              </b-col>
              <b-col md="2">
              </b-col>
              <b-col md="5">
                <label class="labels">Engine *</label>
                <b-form-input name="engine" v-model="model.engine" placeholder="Enter Engine" v-bind:class="errors.has('engine') ? 'is-invalid':''" v-validate="modelValidations.engine" :error="errors.first('engine')"  />
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="5">
                <label class="labels">Year *</label>
                <b-form-input type="number" name="year" v-model="model.year" placeholder="Enter Year" v-bind:class="errors.has('year') ? 'is-invalid':''" v-validate="modelValidations.year" :error="errors.first('year')"  />
              </b-col>
              <b-col md="2">
              </b-col>
              <b-col md="5">
                <label class="labels">Transmission *</label>
                <b-form-input name="transmission" v-model="model.transmission" placeholder="Enter Transmission" v-bind:class="errors.has('transmission') ? 'is-invalid':''" v-validate="modelValidations.transmission" :error="errors.first('transmission')"  />
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="5">
                <label class="labels">Chassis Number *</label>
                <b-form-input name="chassisNumber" v-model="model.chassisNumber" placeholder="Enter Chassis Number" v-bind:class="errors.has('chassisNumber') ? 'is-invalid':''" v-validate="modelValidations.chassisNumber" :error="errors.first('chassisNumber')"  />
              </b-col>
              <b-col md="2">
              </b-col>
              <b-col md="5">
                <label class="labels">Machine Number *</label>
                <b-form-input name="machineNumber" v-model="model.machineNumber"  placeholder="Enter Machine Number" v-bind:class="errors.has('machineNumber') ? 'is-invalid':''" v-validate="modelValidations.machineNumber" :error="errors.first('machineNumber')"  />
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="5">
                <label class="labels">Owner *</label>
                <b-form-input name="owner" placeholder="Enter Owner Name" v-model="model.owner" v-bind:class="errors.has('owner') ? 'is-invalid':''" v-validate="modelValidations.owner" :error="errors.first('owner')"  />
              </b-col>
              <b-col md="2">
              </b-col>
              <b-col md="5">
                <label class="labels">Note</label>
                <b-form-textarea name="note" rows="3" placeholder="Enter Note" v-model="model.note" v-bind:class="errors.has('note') ? 'is-invalid':''" v-validate="modelValidations.note" :error="errors.first('note')"  />
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Services">
            <b-row>
              <b-col md="4">
                <label class="labels">Insurance *</label>
                <b-form-datepicker
                  id="insurance"
                  name="insurance"
                  v-model="model.insurance"
                  v-validate="modelValidations.insurance"
                  v-bind:class="errors.has('insurance') ? 'is-invalid':''"
                  locale="en-US"
                  placeholder="No Date Selected"
                  :date-format-options="{ year: 'numeric', day: '2-digit', month: 'long' }"
                ></b-form-datepicker>
                <!-- <date-picker v-model="model.nextservice" type="date" format="YYYY-MM-DD" placeholder="Enter next service date" /> -->
              </b-col>
              <!-- <b-col md="4">
                <label class="labels">Next Service *</label>
                <b-form-datepicker
                  id="nextservice"
                  name="nextservice"
                  v-model="model.nextservice"
                  v-validate="modelValidations.nextservice"
                  v-bind:class="errors.has('nextservice') ? 'is-invalid':''"
                  locale="en-US"
                  :date-format-options="{ year: 'numeric', day: '2-digit', month: 'long' }"
                ></b-form-datepicker>
                <!-- <date-picker v-model="model.nextservice" type="date" format="YYYY-MM-DD" placeholder="Enter next service date" />-->
              <!-- </b-col> -->
            </b-row>
            <b-row>
              <b-col md="4 mt-3">
                <label class="labels">Road Tax *</label>
                <b-form-datepicker
                  id="roadtax"
                  name="roadtax"
                  v-validate="modelValidations.roadtax"
                  v-bind:class="errors.has('roadtax') ? 'is-invalid':''" 
                  v-model="model.roadtax"
                  locale="en-US"
                  placeholder="No Date Selected"
                  :date-format-options="{ year: 'numeric', day: '2-digit', month: 'long' }"
                ></b-form-datepicker>
                <!-- <date-picker v-model="model.roadtax" type="date" format="YYYY-MM-DD" placeholder="Enter road tax date" /> -->
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
        <b-row class="mt-3">
          <b-col md="6">
            <b-button variant="secondary" class="btn-back float-left" @click="goBack()"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
          </b-col>
          <b-col md="6">
            <b-button :variant="$route.params.uuid !== undefined ? 'warning' : 'primary'" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{$route.params.uuid !== undefined ? 'Update' : 'Save'}} </b-button>
          </b-col>
        </b-row>
      </div>
    </form>
    <branch-modal ref="branchModal" v-on:getBranch="getBranch"/>
    <category-modal ref="categoryModal" v-on:getCategory="getCategory"/>
  </b-card>
</template>

<script>
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'
  import BranchModal from './BranchModal'
  import CategoryModal from './CategoryModal'
  
  export default {
    components: {
      DatePicker,
      BranchModal,
      CategoryModal
    },
    data () {
      return {
        isLoading: false,
        isLoadingBranch: false,
        dataAccount: this.$store.getters['account/accountData'],
        apiUrl: {
          vehicle: window.AppConfig.apiUrl + 'vehicle',
          branch: window.AppConfig.apiUrl + 'branch',
        },
        model: {
          category: null,
          merk: '',
          model: '',
          year: '',
          chassisNumber: '',
          machineNumber: '',
          color: '',
          fuel: '',
          engine: '',
          transmission: '',
          owner: '',
          plate: '',
          // nextservice: '',
          insurance: '',
          note: '',
          roadtax: '',
          branch: '',
          company: null
        },
        categoryList: [],
        companyList: [],
        branchList: [{
          value: "",
          text: 'Please Select Branch'
        }],
        modelValidations: {
          category: {
            required: true
          },
          merk: {
            required: true
          },
          model: {
            required: true
          },
          year: {
            required: true
          },
          chassisNumber: {
            required: true
          },
          machineNumber: {
            required: true
          },
          color: {
            required: true
          },
          fuel: {
            required: true
          },
          engine: {
            required: true
          },
          transmission: {
            required: true
          },
          owner: {
            required: true
          },
          plate: {
            required: true
          },
          nextservice: {
            required: true
          },
          note: {
            required: false
          },
          roadtax: {
            required: true
          },
          branch: {
            required: true
          },
          company: {
            required: true
          },
          insurance: {
            required: true
          }
        },
      }
    },
    watch: {
      '$route.params.uuid': function (val) {
        this.initData()
      },
      'model.company' (value) {
        this.getBranch(value)
      }
    },
    mounted() {
      this.initData()
      this.getCategory()
      // this.getBranch()
      this.getCompany()
    },
    methods: {
      initData () {
        if (this.$route.params.uuid !== undefined) {
          this.getDetail()
        }
      },
      getDetail () {
        this.$http.get(this.apiUrl.vehicle + '/' + this.$route.params.uuid)
        .then(response => {
          this.model.category = response.data.category.uuid !== null ? response.data.category.uuid : '-'
          this.model.merk = response.data.merk
          this.model.model = response.data.model
          this.model.year = response.data.year
          this.model.machinecc = response.data.machinecc
          this.model.chassisNumber = response.data.chassisNumber
          this.model.machineNumber = response.data.machineNumber
          this.model.color = response.data.color
          this.model.fuel = response.data.fuel
          this.model.engine = response.data.engine
          this.model.transmission = response.data.transmission
          this.model.owner = response.data.owner
          this.model.plate = response.data.plate
          this.model.insurance = this.$moment(new Date(response.data.insurance)).format('YYYY-MM-DD')
          // this.model.nextservice = this.$moment(new Date(response.data.nextservice)).format('YYYY-MM-DD')
          // this.model.nextservice = response.data.nextservice
          this.model.note = response.data.note
          this.model.roadtax = response.data.roadtax
          this.model.branch = response.data.branch.uuid
          this.model.company = response.data.company !== null ? response.data.company.uuid : '-'
        })
        .catch(error => {
          this.$store.dispatch('notification/error', error)
          this.$router.push('/notfound')
        })
      },
      getBranch (companyUuid = null) {
        this.isLoadingBranch = true
        this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1').then(resp => {
          this.branchList = []
          this.isLoadingBranch = false
          resp.data._embedded.branch.forEach(data => {
            this.branchList.push({
              value: data.uuid,
              text: data.name
            })
          })
        }).catch(error => {
          window.consoleLog(error)
          this.isLoadingBranch = false
        })
      },
      getCompany () {
        this.$http.get(window.AppConfig.apiUrl + 'company?limit=1000').then(resp => {
          this.companyList = []
          resp.data._embedded.company.forEach(data => {
            this.companyList.push({
              value: data.uuid,
              text: data.name
            })
          })
        })
      },
      getCategory () {
        this.$http.get(window.AppConfig.apiUrl + 'vehicle-category?limit=10000').then(resp => {
          this.categoryList = []
          resp.data._embedded.vehicleCategory.forEach(data => {
            this.categoryList.push({
              value: data.uuid,
              text: data.name
            })
          })
        })
      },
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            if (this.$route.params.uuid !== undefined) {
              this.$http.patch(this.apiUrl.vehicle + '/' + this.$route.params.uuid, this.model).then(response => {
                this.$store.dispatch('notification/success', 'Vehicle has been updated.')
                window.location.href = document.URL.replace('/edit', '')
              }).catch(error => {
                this.$store.dispatch('notification/error', error)
              })
            } else {
              this.$http.post(this.apiUrl.vehicle, this.model).then(response => {
                this.$store.dispatch('notification/success', 'Vehicle has been added.')
                window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
              }).catch(error => {
                this.$store.dispatch('notification/error', error)
              })
            }
          } else {
            swal("", "Please fill the required fields!", "info", {
              buttons: false,
              timer: 2000
            });
          }
        })
      },
      goBack () {
        window.goBack(this)
      },
      doModalBranch () {
        this.$refs.branchModal.showModal()
      },
      doModalCategory () {
        this.$refs.categoryModal.showModal()
      }
    }
  }
</script>